import { Injectable } from "@angular/core";

import { BaseService } from "../abstracts/base.service";
import { StudentModel } from "../models/student.model";
import { AddressModel } from "../models/address.model";
import { ResultModel } from "../models/result.model";
import { map } from 'rxjs/operators';
import { LessonModel } from '../models/lesson.model';
import { ClassModel } from '../models/class.model';
import { SubjectModel } from '../models/subject.model';
import { QuestionModel } from '../models/question.model';
import { QuestionMessageModel } from '../models/question-message.model';
import { ClassLevelModel } from '../models/classlevel.model';
import { AppointmentModel } from '../models/appointment';
import { CompanyModel } from "../models/finance/company.model";

@Injectable({
  providedIn: "root",
})
export class StudentUserService extends BaseService {

  getCurrentStudent() {
    return this.httpClient.get<{ Success: boolean, Message: string, Student: StudentModel, Address: AddressModel,Company:CompanyModel, ClassID }>(this.getApiUrl("student"));
  }

  listAllLessons(formData: FormData) {
    return this.httpClient.post<ResultModel<LessonModel[]>>(this.getApiUrl("student/lessons"), formData);
  }

  listLessonSubjects(classLesson: { classID: ClassModel, lessonID: LessonModel }) {
    return this.httpClient.get<ResultModel<SubjectModel[]>>(this.getApiUrl(`student/classes/${classLesson.classID}/lessons/${classLesson.lessonID}/subjects`));
  }

  listLessonSubjectsForDataTable(formData: FormData, classLesson: { classID: ClassModel, lessonID: LessonModel }) {
    return this.httpClient.post<ResultModel<SubjectModel[]>>(this.getApiUrl(`student/classes/${classLesson.classID}/lessons/${classLesson.lessonID}/subjects`), formData);
  }

  getClassLevel(id: string) {
    return this.httpClient.get<{ ClassLevel: ClassLevelModel }>(this.getApiUrl('classlevels/' + id));
  }

  listLessonOnlineLecturesForDataTable(classID: string, lessonID: string, formData: FormData) {
    return this.httpClient.post<ResultModel<any[]>>(this.getApiUrl(`student/classes/${classID}/lessons/${lessonID}/online-lectures`), formData);
  }


  updateProfile(student: any) {
    return this.httpClient.put<ResultModel>(this.getApiUrl("student/profile"), student);
  }


  listVirtualClassesForDataTable(formData: FormData) {
    return this.httpClient.post<ResultModel<any[]>>(this.getApiUrl(`student/virtual-classes`), formData);
  }


  listAllAppointment(formData: FormData) {
    return this.httpClient.post<ResultModel<AppointmentModel[]>>(this.getApiUrl(`student/appointments`), formData);
  }
  

}
